export default "__VITE_ASSET__Tt2oYu7t__"